/*
 * @Description: 
 * @Author: liusilin
 * @Date: 2022-11-02 17:15:38
 * @LastEditors: liusilin
 * @LastEditTime: 2022-11-04 17:36:32
 */
const state = {
    medalList: {},
    giftList: [],
    giftOrderedList: []
  };
  
const mutations = {
    SET_MEDALLIST: (state, medalList) => {
        state.medalList = medalList;
    },
    SET_GIFTLIST: (state, giftList) => {
        const giftListDic = {};
        giftList?.map(item => {
            giftListDic[item.id] = item;
        });
        state.giftList = giftListDic;
        state.giftOrderedList = giftList;
    },
};

export default {
    namespaced: true,
    state,
    mutations
};
  
  